module.exports = __webpack_public_path__ + "img/arrow.4ca122c0.png";